import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['togglable']

  onChange(event) {
    this.togglableTargets.forEach(togglable => {
      let match = true

      if (event.currentTarget.type == 'checkbox') {
        match = match && event.currentTarget.checked
      } else {
        match = match && togglable.dataset.togglableValue.split(',').indexOf(event.currentTarget.value) > -1
      }

      if (match) {
        togglable.classList.remove('hide')
      } else {
        togglable.classList.add('hide')
      }
    })
  }
}
